function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.888337 7.00726L6.6735 12.7923C6.80731 12.9262 6.98592 13 7.17638 13C7.36683 13 7.54545 12.9262 7.67925 12.7923L8.10529 12.3664C8.38251 12.0888 8.38251 11.6378 8.10529 11.3606L3.24734 6.5027L8.11068 1.63936C8.24448 1.50545 8.31836 1.32694 8.31836 1.13659C8.31836 0.946033 8.24448 0.767523 8.11068 0.633508L7.68464 0.207682C7.55073 0.0737724 7.37222 9.236e-07 7.18177 9.17546e-07C6.99131 9.11492e-07 6.8127 0.0737724 6.67889 0.207682L0.888337 5.99802C0.754216 6.13236 0.680551 6.31171 0.680973 6.50238C0.680551 6.69378 0.754216 6.87303 0.888337 7.00726Z",
  fill: "black"
});

var SvgLessonbackicon = function SvgLessonbackicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLessonbackicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lessonbackicon.b66205e7.svg";
export { ForwardRef as ReactComponent };